export const SET_IS_UPDATE_NEEDED = 'SET_IS_UPDATE_NEEDED';
export const SET_PREMIUM = 'SET_PREMIUM';

export default {
  SET_IS_UPDATE_NEEDED,
  SET_PREMIUM,
};
